<ng-container [ngSwitch]="statusNumber">
  <ng-container
    *ngSwitchCase="0"
    [ngTemplateOutlet]="proposalTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="4"
    [ngTemplateOutlet]="proposalTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="20"
    [ngTemplateOutlet]="changeOrderTemplate"
  ></ng-container>
</ng-container>

<ng-template #proposalTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Proposals</mat-label>
          <input
            matInput
            (keyup)="filterProposals($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="proposalDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Created Date
          </th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.createdDate | date : "shortDate" : "UTC" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customer">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.customer || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobaddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.jobaddress || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="discountedTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.discountedTotal | currency : "USD" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="proposalId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal ID</th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.proposalId | slice : 0 : 8 || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
          <td mat-cell *matCellDef="let proposal">
            {{ proposal.assignedName || "n/a" | titlecase }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No matching proposals found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="goToProposal(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>

<ng-template #changeOrderTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Proposals</mat-label>
          <input
            matInput
            (keyup)="filterProposals($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="changeOrderDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="projectid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ProjectId</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.projectid || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Id</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.customerId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobAddressId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Job Address Id
          </th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.jobAddressId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="discountedTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.discountedTotal | currency : "USD" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.assignedName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Created Date
          </th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.createdDate | date : "shortDate" : "UTC" || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let changeOrder">
            {{ changeOrder.description || "n/a" }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="changeOrderDisplayedColumns; sticky: true"
        ></tr>
        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td
            class="mat-cell"
            [attr.colspan]="changeOrderDisplayedColumns.length"
          >
            No pending change orders found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: changeOrderDisplayedColumns"
          (click)="goToChangeOrder(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>
